export const SET_LOADING = "SET_LOADING";
export const SET_ERRORS = "SET_ERRORS";
export const SET_FILTERS = "SET_FILTERS";

export const GET_VENDORS = "GET_VENDORS";
export const GET_VENDORS_SUCCESS = "GET_VENDORS_SUCCESS";
export const GET_VENDORS_FAILURE = "GET_VENDORS_FAILURE";

export const CREATE_VENDOR = "CREATE_VENDOR";
export const CREATE_VENDOR_SUCCESS = "CREATE_VENDOR_SUCCESS";
export const CREATE_VENDOR_FAILURE = "CREATE_VENDOR_FAILURE";

export const UPDATE_VENDOR = "UPDATE_VENDOR";
export const UPDATE_VENDOR_SUCCESS = "UPDATE_VENDOR_SUCCESS";
export const UPDATE_VENDOR_FAILURE = "UPDATE_VENDOR_FAILURE";

export const DELETE_VENDOR = "DELETE_VENDOR";
export const DELETE_VENDOR_SUCCESS = "DELETE_VENDOR_SUCCESS";
export const DELETE_VENDOR_FAILURE = "DELETE_VENDOR_FAILURE";

export const UPDATE_VENDOR_STATUS = "UPDATE_VENDOR_STATUS";
export const UPDATE_VENDOR_STATUS_SUCCESS = "UPDATE_VENDOR_STATUS_SUCCESS";
export const UPDATE_VENDOR_STATUS_FAILURE = "UPDATE_VENDOR_STATUS_FAILURE";
